import styled from 'styled-components';

export const TableContainer = styled.div`
  padding: 0 1rem 0 1rem;
`;

export const ContainerButtons = styled.div`
  padding: 0 1rem 0 1rem;
`;

export const ButtonsTableContent = styled.div`
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  width: 100%;
  align-items: flex-end;
  justify-content: flex-end;
  height: auto;
  margin-bottom: 1.5rem;
  padding: 15px;
  border-radius: 10px;

  button {
    &:first-child {
      margin-right: 0.5rem;
    }
  }
`;

export const StateZeroTableMessage = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 8rem;

  & > span.title {
    font-size: 0.875rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.blue};
  }

  & > span.description {
    font-size: 0.75rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.grayDark2};
  }
`;
